import {
  Box,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { ReactNode } from 'react';


export type TabMetricSectionLayoutProps = {
  title: string;
  fields?: { label: string ; value: string }[];
  children?: ReactNode | ReactNode[];
};

export const FC = (props: TabMetricSectionLayoutProps) => {
  const theme = useTheme();
  return (
    <Box
      borderRadius='1rem'
      paddingX='1rem'
      border={`1px solid ${theme.palette.gray.light20}`}
      flex='1 1 0'
      paddingY='1rem'
    >
      <Box
        paddingBottom='.5rem'
        borderBottom={`1px solid ${theme.palette.gray.light10}`}
      >
        <Typography
          variant='tabSectionSubheader'
        >
          {props.title}
        </Typography>
      </Box>
      <Stack
        paddingTop='.5rem'
        rowGap='.5rem'
      >
        {props.children}
      </Stack>
    </Box>
  );
};
